import VueRouter from 'vue-router';
import Vue from 'vue';

import { useMainStore } from '../store/index';
import { isAuthenticated, getLoginUrl, getToken } from '@/utils/auth';

import TheDashboard from '@/components/pages/TheDashboard.vue';
import NewCollaborator from '@/components/pages/NewCollaborator.vue';
import ManageProfile from '@/components/pages/ManageProfile.vue';
import GroupsDashboard from '@/components/pages/GroupsDashboard.vue';
import ManageGroup from '@/components/pages/ManageGroup.vue';
import FormPermission from '@/components/pages/FormPermission.vue';
import NewGroup from '@/components/pages/NewGroup.vue';
import Error from '@/components/pages/Error.vue';

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: TheDashboard,
    meta: { componentName: 'TheDashboard' }
  },
  {
    path: '/search/:query?',
    name: 'search',
    component: TheDashboard,
    meta: { componentName: 'TheDashboard' },
    beforeEnter (to, from, next) {
      const store = useMainStore();
      store.search.query = to.params.query;

      next();
    }
  },
  {
    path: '/new/collaborator',
    name: 'newCollaborator',
    component: NewCollaborator,
    meta: { componentName: 'NewCollaborator' }
  },
  {
    path: '/collaborator/:uuid',
    name: 'manageProfile',
    component: ManageProfile,
    meta: { componentName: 'ManageProfile', keepAliveFrom: ['dashboard', 'search'] }
  },
  {
    path: '/groupsDashboard',
    name: 'groupsDashboard',
    component: GroupsDashboard,
    meta: { componentName: 'GroupsDashboard', search: 'group' }
  },
  {
    path: '/groupsDashboard/search/:query?',
    name: 'groupsSearch',
    component: GroupsDashboard,
    meta: { componentName: 'GroupsDashboard', search: 'group' },
    beforeEnter (to, from, next) {
      const store = useMainStore();
      store.search.query = to.params.query;
      next();
    }
  },
  {
    path: '/group/:uuid',
    name: 'manageGroup',
    component: ManageGroup,
    meta: { componentName: 'ManageGroup', keepAliveFrom: ['groupsDashboard', 'groupsSearch'], search: 'group' }
  },
  {
    path: '/group/new',
    name: 'newGroup',
    component: NewGroup,
    meta: { componentName: 'NewGroup', search: 'group' }
  },
  {
    path: '/collaborator/:uuid/permission/new',
    name: 'newPermission',
    component: FormPermission,
    meta: { componentName: 'FormPermission', keepAliveFrom: ['manageProfile'] }
  },
  {
    path: '/collaborator/:uuid/permission/:index',
    name: 'editPermission',
    component: FormPermission,
    meta: { componentName: 'FormPermission', keepAliveFrom: ['manageProfile'] }
  },
  {
    path: '/group/:uuid/permission/:index',
    name: 'editGroupPermission',
    component: FormPermission,
    meta: { componentName: 'FormPermission', keepAliveFrom: ['manageGroup'], search: 'group' }
  },
  {
    path: '/group/:uuid/new/permission',
    name: 'newGroupPermission',
    component: FormPermission,
    meta: { componentName: 'FormPermission', keepAliveFrom: ['manageGroup'], search: 'group' }
  },
  {
    path: '/error',
    name: 'error',
    component: Error,
    meta: { componentName: 'Error' }
  }
];

const router = new VueRouter({
  routes: routes,
  mode: 'history'
});

router.beforeResolve(async (to, from, next) => {
  const isLogged = await isAuthenticated(getToken(), window.location.origin);

  if (!isLogged) {
    window.location.href = getLoginUrl(window.location.origin, process.env.VUE_APP_SSO_CLIENT_ID);
    return next(false);
  }

  return next();
});

router.afterEach((to, from) => {
  const store = useMainStore();
  store.loading = false;

  Vue.nextTick(() => {
    if (from.meta.keepAliveFrom && from.meta.keepAliveFrom.includes(to.name)) {
      store.include.pop();
    }
  });
});

router.beforeEach((to, from, next) => {
  const store = useMainStore();
  if (from.name !== null) {
    // If goes to a route that keeps alive the previous component
    if (to.meta.keepAliveFrom && to.meta.keepAliveFrom.includes(from.name)) {
      store.include.push(from.meta.componentName);
    } else if (!(from.meta.keepAliveFrom && from.meta.keepAliveFrom.includes(to.name))) { // If he is going to a route that keeps
      store.include = [];
    }
  }

  next();
});

export default router;
